/* global Modernizr */

import { Controller } from 'stimulus';

const BREAKPOINT = 991;
const KEY_ESCAPE = 27;

class Navigation extends Controller {
  connect() {
    $(document).keyup((e) => {
      if (e.keyCode === KEY_ESCAPE) {
        $(this.navigationTarget).removeClass('is-open');
        $('body').removeClass('nav-open');
        this.toggleTogglerState(true);
      }
    });
  }

  toggleNavigation() {
    const isOpen = $(this.navigationTarget).hasClass('is-open');

    $(this.navigationTarget).toggleClass('is-open', !isOpen);
    $('body').toggleClass('nav-open', !isOpen);

    this.toggleTogglerState(isOpen);

    if (Modernizr.mq(`(max-width: ${BREAKPOINT}px)`)) {
      $(this.collapseTarget).collapse('toggle');
    }
  }

  toggleTogglerState(state) {
    const expandedText = $(this.togglerTextTarget).data('expanded-text');
    const collapsedText = $(this.togglerTextTarget).data('collapsed-text');

    $(this.togglerTargets).each((i, toggler) => {
      $(toggler)
        .attr('aria-expanded', !state)
        .find('span')
        .text(state ? collapsedText : expandedText);
    });
  }
}

Navigation.targets = [
  'toggler',
  'togglerText',
  'navigation',
  'collapse',
];

export default Navigation;
